module.exports = "//public.getcloudapp.com/packs/media/images/pro@1x-26a5c7bba6cd21fd95ad04819f819434.png";